import { ConvertibleNoteModel } from 'api';

const convertNoteInitLiquidationPref = (notesLedger: ConvertibleNoteModel[], liquidationPreference: number): number => {
  const notes = notesLedger ?? [];
  const values = notes.map(
    ({ expected_shares, conversion_price_per_share }) =>
      Number(expected_shares ?? 0) * Number(conversion_price_per_share ?? 0) * liquidationPreference
  );
  return values.reduce((acc, val) => acc + val, 0);
};
export default convertNoteInitLiquidationPref;
